import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Archives = () => {
  const [archives, setArchives] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArchives();
  }, []);

  const fetchArchives = async () => {
    try {
      const response = await axios.get('/api/issues');
      // Ensure response.data is an array
      if (Array.isArray(response.data)) {
        // Group issues by year
        const groupedByYear = response.data.reduce((acc, issue) => {
          const year = issue.year;
          if (!acc[year]) {
            acc[year] = {
              id: year,
              year: year,
              volumeNumber: issue.volume,
              issues: []
            };
          }
          acc[year].issues.push({
            id: issue.id,
            issueNumber: issue.issue,
            publicationDate: issue.publicationDate,
            pdfUrl: issue.pdfUrl
          });
          return acc;
        }, {});

        // Convert to array and sort by year descending
        const archivesArray = Object.values(groupedByYear).sort((a, b) => b.year - a.year);
        setArchives(archivesArray);
      } else {
        setArchives([]);
      }
    } catch (error) {
      console.error('Error fetching archives:', error);
      setArchives([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h1>Archives</h1>
      <p className="lead">Browse all published issues of FUW Journal of Agriculture and Life Sciences</p>
      
      <div className="row mt-4">
        {loading ? (
          <div className="text-center">Loading archives...</div>
        ) : archives.length > 0 ? (
          archives.map((volume) => (
            <div key={volume.id} className="col-md-12 mb-4">
              <div className="card">
                <div className="card-header">
                  <h4>Volume {volume.volumeNumber} ({volume.year})</h4>
                </div>
                <div className="card-body">
                  {volume.issues && volume.issues.map((issue) => (
                    <div key={issue.id} className="mb-3 pb-3 border-bottom">
                      <h5>Issue {issue.issueNumber}</h5>
                      <p>Published: {new Date(issue.publicationDate).toLocaleDateString()}</p>
                      <div className="btn-group">
                        <Link to={`/issues/${issue.id}`} className="btn btn-primary btn-sm">
                          <i className="fas fa-eye me-1"></i>
                          View Issue
                        </Link>
                        {issue.pdfUrl && (
                          <a
                            href={`/api/public/issues/${issue.id}/download`}
                            className="btn btn-outline-primary btn-sm"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fas fa-download me-1"></i>
                            Download PDF
                          </a>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No archives available.</p>
        )}
      </div>
    </div>
  );
};

export default Archives;